import { about, languages, riskutbildning } from "../mock/mock";
import CTASection from "../components/CTASection";
import useSeo from "../hooks/useSeo";

export default function OmOss() {
  useSeo({ title: "Utbildning", description: "Så går körkortsutbildningen till hos City Trafikskola Uppsala – körlektioner, teori på sex språk, riskettan och halkbana med skjuts tur och retur." });
  return (
    <main className="pt-20 md:pt-[8.25rem]">
      <section className="bg-[#0B2545] py-20">
        <div className="max-w-7xl mx-auto px-5 text-center">
          <span className="text-[#ffce3a] font-semibold tracking-[0.2em] text-xs uppercase">Utbildning</span>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-white mt-3">Om City Trafikskola Uppsala</h1>
          <p className="text-slate-300 mt-4 max-w-2xl mx-auto">{about.intro}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img src={about.image} alt="City Trafikskola Uppsala" className="rounded-2xl shadow-xl w-full h-[420px] object-cover" />
            <div className="absolute -bottom-6 -right-6 bg-[#ffce3a] rounded-2xl px-7 py-5 shadow-lg hidden sm:block">
              <div className="font-display text-3xl font-extrabold text-[#0B2545]">6 språk</div>
              <div className="text-sm font-semibold text-[#0B2545]/70">för teorin</div>
            </div>
          </div>
          <div>
            <span className="text-[#1B6CA8] font-semibold tracking-[0.18em] text-xs uppercase">Om oss</span>
            <h2 className="font-display text-3xl font-bold text-[#0B2545] mt-2">Komplett körkortsutbildning vid Kvarntorget</h2>
            <p className="text-slate-600 mt-4 leading-relaxed">{about.body}</p>
            <div className="mt-6">
              <div className="text-sm font-semibold text-slate-500 mb-2">Teori och undervisning på:</div>
              <div className="flex flex-wrap gap-2">
                {languages.map((l) => (
                  <span key={l} className="px-3 py-1.5 rounded-lg bg-[#f0f5fb] text-[#0B2545] text-sm font-medium">{l}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Riskutbildning */}
      <section id="riskutbildning" className="bg-[#f6f9fc] py-20">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="text-[#1B6CA8] font-semibold tracking-[0.18em] text-xs uppercase">Riskutbildning & teori</span>
            <h2 className="font-display text-3xl font-bold text-[#0B2545] mt-2">Bli en trafiksäker och riskmedveten förare</h2>
            <p className="text-slate-500 mt-3">Båda riskutbildningarna krävs för att få göra kunskaps- och körprovet.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {riskutbildning.map((r) => (
              <div key={r.title} className="bg-white rounded-2xl p-7 border border-slate-100 hover:shadow-lg transition-all">
                <span className="block w-10 h-1 rounded-full bg-[#ffce3a]" />
                <h3 className="font-display font-bold text-lg text-[#0B2545] mt-5">{r.title}</h3>
                <p className="text-sm text-slate-500 mt-2 leading-relaxed">{r.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </main>
  );
}
